/* Routing */
import {Link} from "react-router-dom";
/* Helpers */
import { documentsOrder } from "../../../helper/orders";
/* Components */
import Dashboard from "../../../components/common/dashboard/Dashboard";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import SearchBox from "../../../components/common/SearchBox";
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
import {useEffect, useState} from "react";
import {getAdminDocumentList} from "../../../api/admin/documentReq";
import usePager from "../../../hooks/usePager";


export default function Documents({ tab }) {
    const sources = "fa fa-file-lines";
    const tabSource = "fa fa-bars";
    const { currentPage, setCurrentPage, itemsPerPage, setTotalPages } = usePager();
    const { auth } = useAuth();
    const { documentList, setDocumentList } = useData();
    const [ filterParams, setFilterParams ] = useState({});
    const [ totalItems, setTotalItems ] = useState();
    const token = auth.token;

    const documentsApi = async () => {
        const response = await getAdminDocumentList(token, currentPage, itemsPerPage, JSON.stringify(filterParams));
        setDocumentList(response?.documentList)
        setTotalItems(response?.totalItems)
    }

    useEffect(() => {
        setCurrentPage(1)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ filterParams, totalItems, itemsPerPage ]);

    useEffect(() => {
        if (tab === "documents")
            documentsApi()
    }, [ tab, filterParams, currentPage, itemsPerPage, totalItems ]);

    useEffect(() => {
        if (tab === "documents" && (documentList?.length || 0) < 1) {
            documentsApi()
        }
    }, [ tab,documentList ]);

    const headers = [
        { label: "Nom", key : "name" },
        { label :"Date de création", key : "created_at" },
        { label :"Date de modification", key : "updated_at" },
        { label :"Actif", key : "enabled" },
    ];

    return (
        <main className="admin">
            <Header
                parent="Administration"
                location={tab === "devis" ? "Devis" : "Documents"}
            />
            <div>
                <nav className="tabs-menu">
                    <ul>
                        <li className={ tab === "documents" ? "active" : ""}><Link to="/admin/documents">Voir les documents</Link></li>
                        <li><Link to="/admin/documents/courriers">Gérer les courriers</Link></li>
                        <li><Link to="/admin/documents/devis/section/1/voir">Voir les devis type</Link></li>
                        <li><Link to="/admin/documents/devis/categories">Gérer les catégories</Link></li>
                    </ul>
                </nav>
                <div className="content-container">
                    <Icon source={ sources } color="blue" span="Liste des documents"/>
                    { tab === "documents" && <SearchBox className="documents" location="Documents" headers={headers} filename="Documents" setFilterParams={setFilterParams}/>}
                    { tab === "documents" &&
                        <div className="dashboard document-dashboard">
                                <Dashboard totalItems={totalItems} documentsApi={documentsApi} tab={tab} location="Documents" dataObject={documentList || [] } order={ documentsOrder } />
                        </div>
                    }
                </div>
            </div>
        </main>
    )
}